<template lang="html">
  <div style="overflow-x: hidden; overflow-y: scroll; height: 100vh">
    <div class="header row middle-xs center-xs">
      <div class="col-xs-2"></div>
      <div class="col-xs-8 row bottom-xs center-xs header-text">
        <span class="logo-text">{{ author_name }} is a</span>
        <img
          src="https://s3-us-west-1.amazonaws.com/parlay-staging-files/Logo.svg"
          alt=""
          class="logo"
          style="vertical-align: bottom"
        />
        <span class="logo-text">Trailblazer!</span>
      </div>
      <div class="footer col-xs-2">
        <span>Want to try Parlay in your classroom?</span><br />
        <button @click="toParlaySite" style="margin-top: 10px">
          GET STARTED
        </button>
      </div>
    </div>
    <div v-show="!loading_page" class="sub-header row center-xs middle-xs">
      <span
        >Check out this Chord Diagram from our class <br />
        discussion
        <span
          ><strong>"{{ rt_name }}"</strong></span
        ></span
      >
    </div>
    <div v-if="loading_chord" class="row center-xs">
      <pl-spinner class="x4" style="margin-top: 15%"></pl-spinner>
    </div>
    <chord-diagram
      v-else
      :summary="summary"
      @showEmptyMessage="show_empty_message = true"
      class="chord row center-xs"
    >
    </chord-diagram>
  </div>
</template>

<script>
  import chordDiagram from './chordDiagram.vue';
  import createChordDiagramPublic from 'features/onlineRoundtables/services/dataVisualization/createChordDiagramPublic';
  import { mapGetters } from 'vuex';
  import URLPath from 'services/apiConfigs';

  export default {
    components: {
      chordDiagram,
    },
    data() {
      return {
        summary: [],
        rt_name: '',
        author_name: '',
        show_empty_message: false,
        loading_chord: true,
        loading_page: true,
      };
    },
    computed: {
      ...mapGetters(['getCurrentRT']),
      sharing_url() {
        const roundtableID = this.$route.params.roundtableID;
        return `${URLPath.apiURL}/api/roundtables/${roundtableID}/chord`;
      },
    },
    methods: {
      toParlaySite() {
        window.open('https://parlayideas.com/');
      },
      shareOnTW() {
        const rtTitle = this.getCurrentRT.title;
        const url = this.formatParam(this.sharing_url);
        const text = this.formatParam(
          `Check out this Comment Chord from our class discussion "${rtTitle}" on @parlayideas`
        );
        window.open(
          `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
          '',
          'scrollbars=yes,width=650,height=280'
        );
      },
      shareOnFB() {
        // FB.ui(
        //   {
        //     method: 'share',
        //     href: this.formatParam(this.sharing_url),
        //   },
        //   function (response) {}
        // );
      },
      formatParam(param) {
        return param
          .replace(/%/g, '%25')
          .replace(/ /g, '%20')
          .replace(/\$/g, '%24')
          .replace(/#/g, '%23');
      },
    },
    created() {
      // Facebook Init
      // window.fbAsyncInit = () => {
      //   FB.init({
      //     appId: '1550372328564661',
      //     autoLogAppEvents: true,
      //     xfbml: true,
      //     version: 'v2.12',
      //   });
      // };
      // (function (d, s, id) {
      //   var js,
      //     fjs = d.getElementsByTagName(s)[0];
      //   if (d.getElementById(id)) {
      //     return;
      //   }
      //   js = d.createElement(s);
      //   js.id = id;
      //   js.src = 'https://connect.facebook.net/en_US/sdk.js';
      //   fjs.parentNode.insertBefore(js, fjs);
      // })(document, 'script', 'facebook-jssdk');
    },
    mounted() {
      createChordDiagramPublic(this.$route.params.roundtableID).then(
        (response) => {
          this.summary = response.data.d3information;
          this.rt_name = response.data.rt_name;
          this.author_name = response.data.author;
          this.loading_chord = false;
          this.loading_page = false;
        }
      );
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2)
    .header
      height: 6em !important
    .header-text
      padding: 0 0 1em 0 !important
    .logo
      height: 50px !important
      margin: 12px 0 0 5px !important
    .logo-text
      font-size: 12px !important
      padding: 0px 8px 0px 25px !important
    .sub-header
      font-size: 12px !important
      margin-bottom: 10px !important
      margin-top: 12px !important
      height: 4em !important
    .footer
      visibility: hidden !important
      padding-top: 0px !important
      padding-left: 15px !important
      font-size: 8px !important
      font-weight: bold !important
      color: #fff !important
    button
      font-size: 8px !important
      padding: 0px 4px !important
      margin: 2px 4px !important
      min-height: 22px !important
      min-width: 35px !important


  .header {
    background-color: #283248;
    height: 8em;
  }
  .header-text {
    color: #fff;
    padding: 0 0 10px 0;
  }
  .logo {
    height: 85px;
    padding: 10px 0 0 0;
  }
  .logo-text {
    font-size: 25px;
    padding: 0 12px 7px 12px;
    font-weight: bold;
  }
  .sub-header {
    font-size: 19px;
    margin-bottom: 18px;
    margin-top: 12px;
    height: 4em;
  }
  .footer {
    padding-top: 10px;
    padding-left: 15px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }
  .spinner-container {
    margin-top: 20px;
  }
  .no-margin {
    margin: 0;
  }
  button {
    color: #fff;
    background-color: #72ccd7;
    position: relative;
    overflow: hidden;
    font-family: inherit;
    font-size: 15px;
    white-space: nowrap;
    padding: 0px 12px;
    margin: 6px 8px;
    cursor: pointer;
    border: 0;
    border-radius: 2px;
    min-height: 35px;
    min-width: 120px;
  }
  button:hover {
    background-color: #47c8d7;
  }
</style>



// WEBPACK FOOTER //
// chordDiagramPublic.vue?735527f7